import { useClaims } from '@/hooks/useSession';
import { AppShell } from '@/components/AppShell';
import { GardenShell } from '@/components/GardenShell';

/**
 * Whichever shell this user normally lives in.
 *
 * A route serving students *and* staff — profile settings is the only one — sits
 * outside the per-surface route groups, so it has no shell of its own to inherit.
 * Picking one by role here keeps such a page in the navigation the user already
 * has, rather than stranding them on a chrome-less screen whose only way out is a
 * bespoke back button.
 */
export function RoleShell() {
  const role = useClaims()?.role;
  // SCHOOL_ADMIN and COUNSELLOR live in the staff shell alongside teachers.
  return role === 'TEACHER' || role === 'COUNSELLOR' || role === 'SCHOOL_ADMIN' ? (
    <AppShell />
  ) : (
    <GardenShell />
  );
}
